import { useContext } from 'react';
import {
    ActionDependant,
    GlobalDataContext,
    propsDataLocationToPathAndValue,
    TemplateContext,
} from '@ea-lab/reactive-json';
import { PriorityDropdown } from './priority-icon';

/**
 * PriorityIconField (CDC-TMA T12) — Jira-style priority selector for forms.
 *
 * Reactive-json form element bound via dataLocation (same contract as
 * StarRatingField). Renders a dropdown of the 5 levels (icon + label) plus
 * "Non définie". Read-only when props.readOnly is true.
 *
 * Props:
 *   dataLocation – standard reactive-json form binding
 *   size         – glyph size in px (default 20)
 *   readOnly     – disables interaction (default false)
 */
export const PriorityIconField = ({ props, datafield, path }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);

    const { formData, formDataPath } = propsDataLocationToPathAndValue({
        currentPath: path,
        datafield,
        dataLocation: props.dataLocation,
        defaultValue: 0,
        globalDataContext,
        templateContext,
    });

    const size = props.size ?? 20;
    const readOnly = props.readOnly ?? false;
    const level = Number(formData) || 0;

    const handleChange = (next) => {
        if (readOnly || !globalDataContext?.updateData) return;
        globalDataContext.updateData(next, formDataPath);
    };

    return (
        <ActionDependant {...props}>
            <div className="inline-flex items-center h-[42px] px-1">
                <PriorityDropdown value={level} onChange={handleChange} size={size} showLabel readOnly={readOnly} />
            </div>
        </ActionDependant>
    );
};

export default PriorityIconField;
